import * as React from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { Share2 } from 'lucide-react';
import { FaFacebook, FaTwitter, FaEnvelope } from 'react-icons/fa6';

interface ShareSocialProps {
  url: string;
  title?: string;
  cta?: string;
}

export const ShareSocial: React.FC<ShareSocialProps> = ({
  url,
  title = 'Check this out',
  cta = 'share this',
}) => {
  // Use the provided URL or fallback to current page URL
  const shareUrl = url || (typeof window !== 'undefined' ? window.location.href : '');

  const handleShare = (platform: 'facebook' | 'twitter' | 'linkedin' | 'email') => {
    const encodedUrl = encodeURIComponent(shareUrl);
    const encodedTitle = encodeURIComponent(title);

    let shareLink = '';

    switch (platform) {
      case 'facebook':
        shareLink = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
        break;
      case 'twitter':
        shareLink = `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`;
        break;
      case 'email':
        shareLink = `mailto:?subject=${encodedTitle}&body=${title}: ${encodedUrl}`;
        break;
      default:
        break;
    }

    if (shareLink) {
      window.open(shareLink, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant='default'
          className='flex items-center gap-2'
          size='sm'
        >
          <div className='flex items-center gap-2'>
            <Share2 className='h-4 w-4' />
            {cta}
          </div>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align='end'>
        <DropdownMenuItem onClick={() => handleShare('facebook')}>
          <FaFacebook className='mr-2 h-4 w-4' />
          <span>Facebook</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => handleShare('twitter')}>
          <FaTwitter className='mr-2 h-4 w-4' />
          <span>Twitter</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => handleShare('email')}>
          <FaEnvelope className='mr-2 h-4 w-4' />
          <span>Email</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ShareSocial;
